/* 許褚（字仲康） */
import { defineHero } from '../define.ts';

export default defineHero({
  id: 'xuchu', name: '許褚', sub: '字仲康', faction: 'wei', role: '戰士/坦克', weapon: 'axe',
  look: { head: 'topknot', skin: '#e0a878', bulk: 1.25, size: 1.08, beard: 'bushy', eye: 'fierce', fx: '#ffcf8a', c: { armor: '#4b5872' } },
  skills: [
    ['白熱', 'buff', '4 秒內攻速暴增 +{100/200/300/400}%。', { x: { k: 'buff', as: [100, 200, 300, 400], dur: 4 } }],
    ['暈擊', 'passive', '普攻有 20% 機率附加 {20/25/30/35} 傷害並震暈 {0.5/0.7/1/1.2} 秒。', { pv: { bonus: { chance: 20, dmg: [20, 25, 30, 35], stun: [0.5, 0.7, 1, 1.2] } } }],
    ['力量強化', 'passive', '力量 +{10/17/24/31}。', { pv: { str: [10, 17, 24, 31] } }],
    ['重生', 'passive', '陣亡時原地滿血復活，冷卻 144/126/108 秒。', { pv: { rebirth: [240, 210, 180] } }],
  ],
});
